import type { ReactNode } from "react";

import { translate } from "app/filters/i18nFilter";
import { keywordGroupsQueryClient } from "app/services/keyword-groups/utils/keywordGroupsQueryClient";

export enum EKWReportTableFilters {
    MULTI_INCLUDE_EXCLUDE_KEYWORDS = "multiIncludeExcludeKeywords",
    MULTI_INCLUDE_EXCLUDE_WEBSITES = "multiIncludeExcludeWebsites",
    CHANGE = "Change",
}

const URLS = "URLs";
const KEYWORDS = "Keywords";

interface IIncludeExcludeItem {
    type: "Include" | "Exclude";
    matchType: string;
    items: Array<{ type: "website" | "keywords"; value: string }>;
}

const getSubItemDisplayValue = async (subItem: any) => {
    const keywordGroup = await keywordGroupsQueryClient.getGroupById(subItem.value ?? subItem.id);
    return keywordGroup?.Name
        ? `"${keywordGroup.Name}" ${translate("includeExclude.filters.dashboard.tooltip")}`
        : `"${subItem.value ?? subItem.text}"`;
};

export const getItemDisplayValue = async (item: any, type: string) => {
    const subItemsDisplayValues = await Promise.all(item.items.map(getSubItemDisplayValue));
    return `${item.type} ${item.matchType ?? item.match} ${type}: ${subItemsDisplayValues.join(", ")}`;
};

export const parseIncludeExcludeForTooltip = async (value: IIncludeExcludeItem[], type: string) => {
    const resultString = await Promise.all(value.map((item) => getItemDisplayValue(item, type)));
    const divCount = resultString.length;
    const divElements: ReactNode = resultString.map((item, index) => <div key={index}>{item}</div>);
    return { divElements, divCount };
};

export type FilterLogicFunction = (filters: any) => Promise<{ divElements: ReactNode; divCount: number } | null>;

export const KWReportWidgetFiltersMap: Record<EKWReportTableFilters, FilterLogicFunction> = {
    [EKWReportTableFilters.MULTI_INCLUDE_EXCLUDE_KEYWORDS]: async (filters) =>
        filters.multiIncludeExcludeKeywords
            ? await parseIncludeExcludeForTooltip(JSON.parse(filters.multiIncludeExcludeKeywords), KEYWORDS)
            : null,
    [EKWReportTableFilters.MULTI_INCLUDE_EXCLUDE_WEBSITES]: async (filters) =>
        filters.multiIncludeExcludeWebsites
            ? await parseIncludeExcludeForTooltip(JSON.parse(filters.multiIncludeExcludeWebsites), URLS)
            : null,
    [EKWReportTableFilters.CHANGE]: async (filters) =>
        filters.Change
            ? {
                  divCount: 1,
                  divElements: translate("dashboard.metrics.landing.page.table.change.filter", {
                      change: filters.Change,
                  }),
              }
            : { divCount: 0, divElements: null },
};

export const KWReportTableWidgetAPIParams = ["multiIncludeExcludeKeywords", "multiIncludeExcludeWebsites", "Change"];
